import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';

import {Slide1, Slide2, Slide3, Slide4} from './illustrations';
import {MeetingBooking, Availability, BuiltIntoCRM, MoreFeatures} from './pages';

const arts = [
    {
        background: colors.plumLt,
        image: () => <ImageWrapper image={<Slide1 />} width={300} />,
    },
    {
        background: colors.plumLt,
        image: () => <ImageWrapper image={<Slide2 />} width={300} />,
    },
    {
        background: colors.plumLt,
        image: () => <ImageWrapper image={<Slide3 />} width={210} />,
    },
    {
        background: colors.plumLt,
        image: () => <ImageWrapper image={<Slide4 />} width={300} />,
    },
];

export const pages = [
    {
        id: 'meeting-booking',
        body: <MeetingBooking />,
        art: arts[0],
    },
    {
        id: 'availability',
        body: <Availability />,
        art: arts[1],
    },
    {
        id: 'built-into-crm',
        body: <BuiltIntoCRM />,
        art: arts[2],
    },
    {
        id: 'more-features',
        body: <MoreFeatures />,
        art: arts[3],
    },
] as const;
